import React from "react";
import {LinearProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import {classes} from "../api/constants";

const TMDetailSingle = ({trademark}) => {
    console.log(trademark)
    return (
        <TableContainer>
            <Table aria-label="simple table">
                <TableHead className='bg-gray-50'>
                    <TableCell colSpan={2}><p className='text-center text-lg bg-gray-50 w-lg'>Trademark Details</p>
                    </TableCell>
                </TableHead>

                {trademark.application_number ?
                    <TableBody>
                        <TableRow>
                            <TableCell>Word Mark</TableCell>
                            <TableCell>{trademark.wordmark}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Application No.</TableCell>
                            <TableCell>{trademark.application_number}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Application Date</TableCell>
                            <TableCell>{trademark.application_date}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Proprietor</TableCell>
                            <TableCell>{trademark.proprietor}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Journal No.</TableCell>
                            <TableCell>{trademark.journal_number}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Journal Date</TableCell>
                            <TableCell>{trademark.journal_date}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Valid Upto</TableCell>
                            <TableCell>{trademark.valid_upto}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Status</TableCell>
                            <TableCell>{trademark.status}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Goods & Services description</TableCell>
                            <TableCell className='max-w-md'>{trademark.goods_and_services}</TableCell>
                        </TableRow>
                    </TableBody>

                    :
                    <LinearProgress/>
                }

            </Table>
        </TableContainer>

    )
}

export default TMDetailSingle;